import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import AuthContext from '../../../store/AuthContext';
import Button from '../../formInputs/button/Button';
import TextBox from '../../formInputs/textBox/TextBox';
import './RequestModal.css';
import { Link, useNavigate } from 'react-router-dom';
import FormUpload from '../../formUpload/FormUpload';
import PropertyFormat, {
    amountFormat,
    RemoveUnderscoreWithUppercase,
} from '../../commonLayouts/PropertyFormat/PropertyFormat';
import SelectBox from '../../formInputs/selectBox/SelectBox';
import { createProfile } from '../../../redux/actions/requestApi';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
    getRequestsDataForRole,
    getFacilityUpdateUrl,
    getCreditDebitFlag,
    getUpdatedFacilityDisplayValue,
    getSubmitUpdateType,
    applyFacilityAmountChange,
    applyKycCustomDocuments,
    applySupplierFeeDetails,
    runUpdateFacilityValidation,
    applyCreditEngineRequestIds,
    isAmountRequiredRequest,
    isCreditExtensionRequest,
    isProfileTypeRequest,
    appendPayloadFiles,
    applyInitialRequestSelections,
} from './RequestModal.helpers';

function submitKycDocuments({
    props,
    comment,
    ctx,
    selectedRequest,
    selectedCategory,
    selectedSubCategory,
    requestDocs,
    baseUrlReq,
    navigate,
}) {
    let payload = null;
    const formData = new FormData();
    appendPayloadFiles(formData, props.payload);
    const newPayload = {
        description: comment,
        organization_ulid: ctx.userData.user_organizations[0].organization_ulid,
        request_type: props.requestType === 'profile_update' ? props.requestType : selectedRequest,
        requestor_ulid: ctx.userData.ulid,
        update_type: props.requestType === 'profile_update' ? props.updateType : selectedCategory,
        user_ulid: ctx.userData.ulid,
        payload: payload,
        sub_categories: selectedSubCategory === 'Select' ? '' : selectedSubCategory,
        request_documents: requestDocs,
    };
    formData.append('request', JSON.stringify(newPayload));
    axios
        .put(`${baseUrlReq}/updateProfile`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => {
            if (res.status === 200) {
                const link = (
                    <Link to='/requests'>
                        {res.data.serviceMessage}
                        <span className='text-secondary-300'> Click here to Track Requests</span>
                    </Link>
                );
                props.setShowMsgModal(true);
                props.setModalTitle(link);
                props.setModalType('success');
                props.handleRequestCloseModal();
                if (
                    props?.profileType === 'buyer' ||
                    props?.profileType === 'supplier' ||
                    props?.profileType === 'investor'
                ) {
                    toast.info(res.data.serviceMessage, {
                        icon: <span className='msg-icon float-start pe-2 sf-info-filled info-icon'></span>,
                        autoClose: false,
                        closeOnClick: true,
                    });
                    navigate('/manageProfiles');
                }
            }
        })
        .catch((error) => {
            if (error.status === 401) {
                ctx.onLogout();
            }
        });
}

function submitBrokerProfile({ props, comment, requestDocs, dispatch, navigate }) {
    const { formData, payloadUpdate, status, actionType, userId } = props.payload;
    payloadUpdate.description = comment;
    payloadUpdate.request_documents = requestDocs;
    formData.append('request', JSON.stringify(payloadUpdate));
    const reqPay = { req: formData, status, actionType, userId };
    dispatch(createProfile(reqPay));
    props.handleRequestCloseModal();
    navigate('/manageProfiles');
}

function buildDefaultRequestPayload({
    props,
    comment,
    ctx,
    selectedRequest,
    selectedCategory,
    selectedSubCategory,
    requestDocs,
    createPayloadforSpotCreditExtension,
    createPayloadforTrialKnotsRiskDecisions,
    createPayloadForSubmit,
}) {
    let payload = null;
    if (isCreditExtensionRequest(props)) {
        payload = createPayloadforSpotCreditExtension();
    } else if (isProfileTypeRequest(props)) {
        payload = props.payload;
        delete payload?.termSheet?.deleted_termsheet_document;
        payload = applyKycCustomDocuments(props.payload);
        if (props?.profileType === 'supplier') {
            payload = applySupplierFeeDetails(props.payload);
        }
    } else if (props.requestType === 'set_buyer_credit') {
        payload = createPayloadforTrialKnotsRiskDecisions();
    } else if (!props.isUpdateByUserOnly) {
        payload = createPayloadForSubmit();
    }

    let newPayload;
    if (props.requestType === 'set_buyer_credit') {
        newPayload = payload;
    } else {
        newPayload = {
            description: comment,
            organization_ulid: ctx.userData.user_organizations[0].organization_ulid,
            request_type: props.requestType === 'profile_update' ? props.requestType : selectedRequest,
            request_documents: requestDocs,
            requestor_ulid: ctx.userData.ulid,
            update_type: getSubmitUpdateType(props, selectedCategory),
            user_ulid: ctx.userData.ulid,
            payload: payload,
            sub_categories: selectedSubCategory === 'Select' ? '' : selectedSubCategory,
        };
    }
    return applyCreditEngineRequestIds(newPayload, props.updateRequestData);
}

function postNewRequest({ props, formData, baseUrlReq, ctx, navigate }) {
    axios
        .post(`${baseUrlReq}/request`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => {
            if (res.status === 200) {
                const renderLinkColumn = () => (
                    <Link to='/requests'>
                        {res.data.serviceMessage}{' '}
                        <span className='text-secondary-300'> Click here to Track Requests</span>
                    </Link>
                );
                const modalTitle =
                    props.currentRouteUrl !== '/requests' ? renderLinkColumn() : res.data.serviceMessage;
                props.setShowMsgModal(true);
                props.setModalType('success');
                props.setModalTitle(modalTitle);
                if (isCreditExtensionRequest(props)) {
                    props.handleRequestCloseModal(res.status);
                } else {
                    props.handleRequestCloseModal();
                    toast.info(res.data.serviceMessage, {
                        icon: <span className='msg-icon float-start pe-2 sf-info-filled info-icon'></span>,
                        autoClose: false,
                        closeOnClick: true,
                    });
                    navigate('/manageProfiles');
                }
            }
        })
        .catch((error) => {
            if (error.response && error.response.status === 401) {
                ctx.onLogout();
            }
            if (error.response && error.response.status === 400) {
                props.handleRequestCloseModal();
                props.setShowMsgModal(true);
                props.setModalType('error');
                props.setModalTitle(error.message);
            }
        });
}

function putUpdateRequest({ props, formData, baseUrlReq, ctx }) {
    axios
        .put(`${baseUrlReq}/request`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => {
            if (res.status === 200) {
                props.handleRequestCloseModal();
                toast.info(res.data.serviceMessage, {
                    icon: <span className='msg-icon float-start pe-2 sf-info-filled info-icon'></span>,
                    autoClose: false,
                    closeOnClick: true,
                });
            }
        })
        .catch((error) => {
            if (error.response && error.response.status === 401) {
                ctx.onLogout();
            }
            if (error.response && error.response.status === 400) {
                props.handleRequestCloseModal();
                props.setShowMsgModal(true);
                props.setModalType('error');
                props.setModalTitle('Invalid or missing request data');
            }
        });
}

function RequestModal(props) {
    const navigate = useNavigate();
    const baseUrlReq = process.env.REACT_APP_REQUEST_MANAGEMENT;
    const baseUrlFacility = process.env.REACT_APP_FACILITIES_MANAGEMENT;
    const ctx = useContext(AuthContext);
    const maxCount = 255;
    const [comment, setComment] = useState('');
    const [totalCount, setTotalCount] = useState(maxCount);
    const [amount, setAmount] = useState(null);
    const [amountError, setAmountError] = useState('');
    const [amountErrorMessage, setAmountErrorMessage] = useState('');
    const [, setSelectedFiles] = useState([]);
    const [isfileError, setIsfileError] = useState(false);

    const [selectedRequest, setSelectedRequest] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubCategory, setSelectedSubCategory] = useState('');

    const [facilityUpdateType, setFacilityUpdateType] = useState(null);
    const [facilityUpdateTypeError, setFacilityUpdateTypeError] = useState();
    const [facilityUpdateTypeErrorMsg, setFacilityUpdateTypeErrorMsg] = useState();
    const [facilityAmount, setFacilityAmount] = useState(null);
    const [facilityAmountError, setFacilityAmountError] = useState(false);
    const [facilityAmountErrorMsg, setFacilityAmountErrorMsg] = useState();
    const [masterSpotWorkingCapitalDetails, setMasterSpotWorkingCapitalDetails] = useState([]);
    const [availableBuyerCreditBalance, setAvailableBuyerCreditBalance] = useState(null);
    const [requestDocs, setRequestDocs] = useState([]);

    const [requestsData] = useState(
        getRequestsDataForRole(ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role)
    );

    const filteredCategories = requestsData.find((request) => request.value === selectedRequest)?.categories || [];
    const filteredSubCategories =
        filteredCategories.find((category) => category.value === selectedCategory)?.sub_categories || [];

    const handleComment = (e) => {
        const newText = e.target.value;
        const enteredCharCount = newText.length - comment.length;
        const updatedTotalCount = totalCount - enteredCharCount;

        if (updatedTotalCount >= 0) {
            setComment(newText);
            setTotalCount(updatedTotalCount);
        }
    };
    const handleUploadDoc = (docs, req) => {
        const newDocs = req.map((item) => ({
            document_ulid: item.payload?.document_ulid,
        }));

        setRequestDocs((prev) => [...prev, ...newDocs]);
    };

    const getFileErrors = (errors) => {
        const hasError = errors.some((err) => err.error !== null);
        setIsfileError(hasError);
    };

    const createPayloadforSpotCreditExtension = () => {
        let org_ulid = null;
        let finalRequestType = null;
        if (props.requestType === 'supplier_facility_credit_extension') {
            org_ulid = props.supplierId;
            finalRequestType = props.requestType;
        }
        if (
            props.type === 'credit_limit_extension' ||
            selectedRequest === 'spot_credit' ||
            props.type === 'offer_limit_extension'
        ) {
            org_ulid = ctx.userData.user_organizations[0].organization_ulid;
            finalRequestType = props.type;
        }
        return {
            description: comment,
            facility_ulid: '0f6516b1-6b97-10a0-b5fc-69a00c516b91',
            organization_ulid: org_ulid,
            request_type: finalRequestType,
            requested_amount: parseFloat(amount),
            requestor_ulid: ctx.userData.ulid,
        };
    };

    const createPayloadforTrialKnotsRiskDecisions = () => {
        return {
            description: comment,
            organization_ulid: ctx.userData.user_organizations[0].organization_ulid,
            request_type: props.requestType,
            requested_amount: props.payload.riskDecision.allocatedCreditLimit,
            update_type: props.updateType,
            requestor_ulid: ctx.userData.ulid,
            payload: props.payload,
        };
    };

    const createPayloadForSubmit = () => {
        return {
            description: comment,
            organization_ulid: ctx.userData.user_organizations[0].organization_ulid,
            request_type: selectedRequest === 'Select' ? '' : selectedRequest,
            requestor_ulid: ctx.userData.ulid,
            update_type: selectedCategory === 'Select' ? '' : selectedCategory,
            user_ulid: ctx.userData.ulid,
        };
    };

    const handleRequestedAmount = (event) => {
        setAmountError(false);
        setAmountErrorMessage();
        const value = event.target.value;
        if (!isNaN(value) && /^\d{0,13}(\.\d{0,2})?$/.test(value)) {
            setAmountError(false);
            setAmountErrorMessage();
            setAmount(value);
        } else {
            setAmountError(true);
            setAmountErrorMessage('Amount must have numeric value');
            setAmount('');
        }
    };

    const getBuyerCreditDetails = (orgId) => {
        const payload = {
            organization_ulid: orgId,
            facility_type: props.facilityType,
        };

        axios
            .post(`${baseUrlFacility}/getFacilityByOrgID`, payload)
            .then((res) => {
                if (res.status === 200) {
                    let availableBalance = res.data.payload[0]?.available_credit_balance
                        ? res.data.payload[0]?.available_credit_balance
                        : res.data.payload[0]?.amount - res.data.payload[0]?.utilized_amount;
                    setAvailableBuyerCreditBalance(availableBalance);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    ctx.onLogout();
                }
            });
    };

    const getFacilityBalance = (facilityType) => {
        const facility = masterSpotWorkingCapitalDetails.find((f) => f.facility_type === facilityType);
        return facility ? facility.amount - facility.utilized_amount : 0;
    };
    const handleFacilityAmount = (e) => {
        applyFacilityAmountChange({
            value: e.target.value,
            facilityUpdateType,
            facilityType: props.facilityType,
            availableBuyerCreditBalance,
            getFacilityBalance,
            setFacilityAmount,
            setFacilityAmountError,
            setFacilityAmountErrorMsg,
        });
    };
    const handleFacilityUpdateType = (e) => {
        setFacilityUpdateTypeError(false);
        setFacilityUpdateType(e.target.value);
    };
    const handlefacilityAmountBlur = (e) => {
        const enteredValue = e.target.value;
        if (enteredValue < 0) {
            setFacilityAmountError(true);
            setFacilityAmountErrorMsg('Value cannot be negative');
        } else {
            setFacilityAmountError(false);
            setFacilityAmountErrorMsg('');
        }
    };

    const handleUpdateFacility = () => {
        runUpdateFacilityValidation({
            facilityUpdateType,
            facilityAmount,
            facilityAmt: props.facilityAmt,
            setFacilityUpdateTypeError,
            setFacilityUpdateTypeErrorMsg,
            setFacilityAmountError,
            setFacilityAmountErrorMsg,
            fetchFacilityUpdate,
            facilityType: props.facilityType,
        });
    };

    const fetchFacilityUpdate = (type) => {
        const url = getFacilityUpdateUrl(type);
        const payload = {
            amount: parseFloat(facilityAmount),
            credit_debit_flag: getCreditDebitFlag(facilityUpdateType),
            facility_name: props.facilityName,
            facility_type: props.facilityType,
            facility_ulid: props.id,
            organization_ulid: props.organizationId,
            utilized_amount: props.facilityUtilizedAmt,
        };

        axios
            .put(`${baseUrlFacility}/${url}`, payload)
            .then((response) => {
                if (response.status === 200) {
                    props.handleRequestCloseModal();
                    props.setShowMsgModal(true);
                    props.setModalTitle(response.data.serviceMessage);
                    props.setModalType('success');
                    props.setUpdatedAmount(
                        facilityUpdateType === 'Withdraw'
                            ? parseFloat(props.facilityAmt) - parseFloat(facilityAmount)
                            : parseFloat(props.facilityAmt) + parseFloat(facilityAmount)
                    );
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const dispatch = useDispatch();
    const handleSubmitRequest = () => {
        if (props.updateType === 'update_facility') {
            handleUpdateFacility();
            return;
        }
        if (props.updateType === 'kyc_documents') {
            submitKycDocuments({
                props,
                comment,
                ctx,
                selectedRequest,
                selectedCategory,
                selectedSubCategory,
                requestDocs,
                baseUrlReq,
                navigate,
            });
            return;
        }
        if (props.updateType === 'update_broker_profile') {
            submitBrokerProfile({ props, comment, requestDocs, dispatch, navigate });
            return;
        }
        const formData = new FormData();
        const newPayload = buildDefaultRequestPayload({
            props,
            comment,
            ctx,
            selectedRequest,
            selectedCategory,
            selectedSubCategory,
            requestDocs,
            createPayloadforSpotCreditExtension,
            createPayloadforTrialKnotsRiskDecisions,
            createPayloadForSubmit,
        });
        formData.append('request', JSON.stringify(newPayload));
        if (isAmountRequiredRequest(selectedRequest)) {
            if (amount === '' || amount === null || amount === undefined) {
                setAmountError(true);
                setAmountErrorMessage('This field is required');
                return;
            }
        }
        if (!props.updateRequestData) {
            postNewRequest({ props, formData, baseUrlReq, ctx, navigate });
        }
        if (props.updateRequestData && props.updateRequestData.request_id) {
            putUpdateRequest({ props, formData, baseUrlReq, ctx });
        }
    };

    const getMasterSpotWorkingCapitalDetails = () => {
        axios
            .get(`${baseUrlFacility}/getMasterSpotWorkingCapitalDetails`)
            .then((response) => {
                if (response.status === 200) {
                    setMasterSpotWorkingCapitalDetails(response.data.payload);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    ctx.onLogout();
                }
            });
    };

    useEffect(() => {
        const shouldLoadFacility = applyInitialRequestSelections(props, {
            setSelectedRequest,
            setAmount,
        });
        if (shouldLoadFacility) {
            getMasterSpotWorkingCapitalDetails();
            getBuyerCreditDetails(props.organizationId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.type]);

    useEffect(() => {
        setSelectedSubCategory('Select');
    }, [selectedRequest]);

    const supplierCreditFacilityExtensionSectionTopLine = () => {
        return (
            <>
                <div className='row'>
                    <div className='col-12 col-xl-4 mb-3'>
                        <p className='text-neutral-600 mb-0 font-b3'>Linked to RFQ</p>
                        <p className='text-neutral-900 font-b3'>{props.rfqId}</p>
                    </div>
                    <div className='col-12 col-xl-4 mb-3'>
                        <p className='text-neutral-600 mb-0 font-b3'>Facility ID</p>
                        <p className='text-neutral-900 font-b3'>{props.facilityId}</p>
                    </div>
                    <div className='col-12 col-xl-4 mb-3'>
                        <p className='text-neutral-600 mb-0 font-b3'>Estimated Deal Value</p>
                        <p className='text-neutral-900 font-b3'>{props.dealValue}</p>
                    </div>
                </div>
            </>
        );
    };

    const supplierCreditFacilityExtensionSectionAmount = () => {
        return (
            <>
                {(selectedRequest === 'credit_limit_extension' ||
                    selectedRequest === 'offer_limit_extension' ||
                    selectedRequest === 'Supplier Spot Credit Extension') && (
                    <div className='col-12 col-xl-4 mb-3'>
                        <TextBox
                            label='Requested Amount'
                            type='text'
                            id='amount'
                            placeholder='$0.00'
                            onChange={handleRequestedAmount}
                            name='amount'
                            value={amount}
                            error={amountError}
                            errorMessage={amountErrorMessage}
                        />
                    </div>
                )}
            </>
        );
    };

    return (
        <>
            <div className='col-12 custom-modal'>
                <div className='d-flex justify-content-center align-items-center vh-100'>
                    <div className='bg-white requestModal'>
                        <p className='text-end mb-0'>
                            <span className='sf-close pe-2 cursor' onClick={props.handleRequestCloseModal}></span>
                        </p>
                        <div className='col-12 px-4 mt-2'>
                            <p className='text-neutral-900 font-h1 font-bold text-start'>Raise a Request</p>
                        </div>

                        {props.requestType !== 'update_facility' ? (
                            <div className='text-start px-4'>
                                {props.requestType === 'profile_update' ? (
                                    <div className='row'>
                                        <div className='col-4'>
                                            <p className='text-neutral-700 font-b3 mb-1'>Request Type</p>
                                            <p className='font-b2 text-neutral-900 mb-5'>
                                                {ctx.userData?.user_organizations[0]?.user_org_role_maps[0]
                                                    ?.platform_role === 'internal_ops' && props.fieldsEditable
                                                    ? PropertyFormat(props.updateType, RemoveUnderscoreWithUppercase)
                                                    : 'Update My Profile'}
                                            </p>
                                        </div>
                                        <div className='col-4'>
                                            <p className='text-neutral-600 font-b3 mb-1'>Category</p>
                                            <p className='font-b2 text-neutral-900'>{props.category}</p>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className='row'>
                                            {props.requestType === 'supplier_facility_credit_extension' &&
                                                supplierCreditFacilityExtensionSectionTopLine()}
                                            <div className='col-12 col-xl-4 mb-3'>
                                                <label className='form-label text-neutral-600 font-b3 mb-1'>
                                                    Request Type
                                                </label>
                                                <select
                                                    className='form-select form-select-sm'
                                                    value={selectedRequest}
                                                    onChange={(e) => {
                                                        setSelectedRequest(e.target.value);
                                                        setSelectedCategory('');
                                                        setSelectedSubCategory('');
                                                    }}
                                                    disabled={props.profileType === 'investor' || props?.disabledType}>
                                                    <option value=''>Select Request Type</option>
                                                    {requestsData.map((request) => (
                                                        <option key={request.value} value={request.value}>
                                                            {request.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            {filteredCategories.length > 0 && (
                                                <div className='col-12 col-xl-4 mb-3'>
                                                    <label className='form-label text-neutral-600 font-b3 mb-1'>
                                                        Category
                                                    </label>
                                                    <select
                                                        value={selectedCategory}
                                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                                        className='form-select form-select-sm'>
                                                        <option value=''>Select Category</option>
                                                        {filteredCategories.map((category) => (
                                                            <option key={category.value} value={category.value}>
                                                                {category.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}

                                            {(props.requestType === 'supplier_facility_credit_extension' ||
                                                props.type === 'credit_limit_extension' ||
                                                selectedRequest === 'credit_limit_extension' ||
                                                selectedRequest === 'spot_credit' ||
                                                props.type === 'offer_limit_extension') &&
                                                supplierCreditFacilityExtensionSectionAmount()}
                                        </div>
                                        <div className='row'>
                                            {filteredSubCategories.length > 0 && (
                                                <div className='col-12 col-xl-4 mb-3'>
                                                    <>
                                                        <label className='form-label text-neutral-600 font-b3 mb-1'>
                                                            Sub Category
                                                        </label>
                                                        <select
                                                            className='form-select form-select-sm'
                                                            value={selectedSubCategory}
                                                            onChange={(e) => setSelectedSubCategory(e.target.value)}>
                                                            <option value=''>Select Sub-Category</option>
                                                            {filteredSubCategories.map((subCategory) => (
                                                                <option
                                                                    key={subCategory.value}
                                                                    value={subCategory.value}>
                                                                    {subCategory.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                                {props.isCreditReviewInfoMessage ? (
                                    <div className='row'>
                                        <div className='col-12 mb-2'>
                                            <p className='font-b2 text-neutral-900 mb-5'>
                                                "All the fields marked with * are required to run the credit engine. Do
                                                you wish to proceed?"
                                            </p>
                                        </div>
                                    </div>
                                ) : null}
                                <div className='row'>
                                    <div className='col-12 col-xl-6 mb-3'>
                                        <FormUpload
                                            multiple={true}
                                            title='Upload Document'
                                            onChangeHandle={(file, req) => handleUploadDoc(file, req)}
                                            getFileErrors={getFileErrors}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 mb-3'>
                                        <p className='float-right font-b3 text-neutral-600 mb-0'>
                                            <span className='float-start'>Comment</span>
                                            <span className='float-end'>
                                                {comment.length}/{maxCount}
                                            </span>
                                        </p>
                                        <textarea
                                            className='form-control font-b2 text-neutral-900'
                                            value={comment}
                                            onChange={handleComment}
                                            maxLength='255'></textarea>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='text-start px-4'>
                                <div className='row'>
                                    <div className='col-4'>
                                        <p className='text-neutral-700 font-b3 mb-1'>Request Type </p>
                                        <select
                                            className='form-select form-select-sm'
                                            defaultValue={props.title}
                                            disabled>
                                            <option value={props.title}>{props.title}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    <div className='col-4'>
                                        <SelectBox
                                            label='Add/Withdraw'
                                            data={[
                                                { name: 'Add', value: 'add' },
                                                { name: 'Withdraw', value: 'withdraw' },
                                            ]}
                                            selectType='defaultDropdown'
                                            name='product'
                                            value={facilityUpdateType}
                                            error={facilityUpdateTypeError}
                                            errorMessage={facilityUpdateTypeErrorMsg}
                                            onChange={(e) => handleFacilityUpdateType(e)}
                                            isRequiredNeeded={true}
                                        />
                                    </div>
                                    <div className='col-4'>
                                        <TextBox
                                            label='Input Value'
                                            type='number'
                                            id='amount'
                                            placeholder='Enter amount'
                                            onChange={handleFacilityAmount}
                                            error={facilityAmountError}
                                            errorMessage={facilityAmountErrorMsg}
                                            name='amount'
                                            value={facilityAmount}
                                            onBlur={(e) => handlefacilityAmountBlur(e)}
                                        />
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    <div className='col-4'>
                                        <p className='text-neutral-700 font-b3 mb-1'>Current Value</p>
                                        <p className='text-neutral-900 font-b3 mb-1'>
                                            {PropertyFormat(props.facilityAmt, amountFormat)}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='text-neutral-700 font-b3 mb-1'>Updated Value</p>
                                        <p className='text-neutral-900 font-b3 mb-1'>
                                            {getUpdatedFacilityDisplayValue(
                                                props.facilityAmt,
                                                facilityAmount,
                                                facilityUpdateType,
                                                PropertyFormat,
                                                amountFormat
                                            )}
                                        </p>
                                    </div>
                                </div>

                                <div className='row mt-4'>
                                    <div className='col-12 col-xl-6 mb-3'>
                                        <FormUpload setSelectedFiles={setSelectedFiles} title='Upload Document' />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 mb-3'>
                                        <p className='float-right font-b3 text-neutral-600 mb-0'>
                                            <span className='float-start'>Comment</span>
                                            <span className='float-end'>
                                                {comment.length}/{maxCount}
                                            </span>
                                        </p>
                                        <textarea
                                            className='form-control font-b2 text-neutral-900'
                                            value={comment}
                                            onChange={handleComment}
                                            maxLength='255'></textarea>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className='col-12 pb-4 px-4'>
                            <div className='text-start p-md-0 d-flex'>
                                <Button type='primary-sm' onClick={handleSubmitRequest} disabled={isfileError}>
                                    Confirm
                                </Button>
                                <span className='mx-2'></span>
                                <Button type='hollow-gray-sm' onClick={props.handleRequestCloseModal}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RequestModal;
